var image_viewer_rtlignore_default = {
  "fontElementMap": "D6L3s",
  "imageFigure": "_2b-8D",
  "imageContainer": "EsRXE",
  "expandContainer": "VsClR",
  "expandIcon": "_99s9K",
  "pointer": "UdkaQ",
  "imageWrapper": "_1xrgp",
  "imageRatio": "Loyz9",
  "image": "aI063",
  "imageOverlay": "_61ttx",
  "imagePreload": "DN-fb",
  "imageHighres": "jfvyx",
  "onlyHighRes": "lLMf4",
  "image_loading": "xnaCj"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
